const HERO_IMG =
    "https://static.prod-images.emergentagent.com/jobs/efbb3015-9a48-4b12-9d34-0b22ad9e0ed2/images/4fde96dea4faad6341c9a6a89781088f52577ae45efe5975d3925a6f7c095b69.png";

import HeroBackdrop from "@/components/aoria/HeroBackdrop";

export default function Hero() {
    const scrollTo = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <section
            data-testid="hero-section"
            id="accueil"
            className="relative pt-32 md:pt-40 lg:pt-48 pb-20 md:pb-28 overflow-hidden"
        >
            <HeroBackdrop variant="flows" />
            <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-end">
                    {/* Text column */}
                    <div className="lg:col-span-7">
                        <div className="reveal flex items-center gap-4 mb-10">
                            <span className="tick" />
                            <span className="eyebrow">
                                Accessibilité cognitive
                            </span>
                        </div>

                        <h1
                            data-testid="hero-headline"
                            className="reveal delay-1 h1 text-[#0D1B2A] text-5xl sm:text-6xl md:text-7xl lg:text-[5.25rem]"
                        >
                            L'intelligence artificielle
                            <span className="block italic text-[#415A77]">
                                est aussi un outil
                            </span>
                            d'accessibilité cognitive.
                        </h1>

                        <p
                            data-testid="hero-subtitle"
                            className="reveal delay-2 mt-10 max-w-2xl text-lg md:text-xl leading-relaxed text-[#1B263B]"
                        >
                            Comprendre comment les outils numériques peuvent
                            réduire certains obstacles cognitifs et renforcer
                            l'autonomie dans les études, le travail et la vie
                            quotidienne.
                        </p>

                        <div className="reveal delay-3 mt-12 flex flex-col sm:flex-row gap-4">
                            <button
                                data-testid="hero-cta-decouvrir"
                                onClick={() => scrollTo("presentation")}
                                className="btn-primary px-8 py-4 text-sm tracking-[0.15em] uppercase"
                            >
                                Découvrir
                            </button>
                            <button
                                data-testid="hero-cta-rejoindre"
                                onClick={() => scrollTo("participer")}
                                className="btn-secondary px-8 py-4 text-sm tracking-[0.15em] uppercase"
                            >
                                Rejoindre le projet
                            </button>
                        </div>

                        <div className="reveal delay-4 mt-16 grid grid-cols-3 gap-6 max-w-xl border-t border-[#E0E1DD] pt-8">
                            <div>
                                <div className="font-serif text-3xl text-[#0D1B2A]">
                                    1/5
                                </div>
                                <div className="text-xs text-[#5C6B7D] mt-1 leading-snug">
                                    personnes rencontrent une particularité
                                    cognitive au cours de leur vie
                                </div>
                            </div>
                            <div>
                                <div className="font-serif text-3xl text-[#0D1B2A]">
                                    0
                                </div>
                                <div className="text-xs text-[#5C6B7D] mt-1 leading-snug">
                                    raison pour que l'accès aux outils
                                    numériques reste inégal
                                </div>
                            </div>
                            <div>
                                <div className="font-serif text-3xl text-[#0D1B2A]">
                                    ∞
                                </div>
                                <div className="text-xs text-[#5C6B7D] mt-1 leading-snug">
                                    manières d'apprendre, de comprendre et de
                                    travailler
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Visual column */}
                    <div className="lg:col-span-5 relative reveal delay-2">
                        <div className="relative aspect-[4/5] w-full overflow-hidden grain">
                            <img
                                src={HERO_IMG}
                                alt="Représentation abstraite de passerelles et de flux d'information, accessibilité cognitive à l'ère numérique"
                                width="1024"
                                height="1280"
                                className="absolute inset-0 w-full h-full object-cover"
                                loading="eager"
                                decoding="async"
                                fetchPriority="high"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#0D1B2A]/30 via-transparent to-transparent" />
                            <div className="absolute bottom-6 left-6 right-6 text-[#FDFDFC]">
                                <div className="eyebrow text-[#FDFDFC]/70">
                                    Aoria, 2026
                                </div>
                                <div className="font-serif text-lg mt-2 leading-snug">
                                    « Transformer la complexité en
                                    compréhension. »
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Abstract flow lines background */}
            <svg
                className="absolute -z-0 right-0 top-1/3 w-1/2 h-1/2 opacity-[0.18] pointer-events-none hidden md:block"
                viewBox="0 0 600 600"
                fill="none"
            >
                <path
                    className="flow-line"
                    d="M-20 100 C 150 200, 350 50, 600 220"
                    stroke="#415A77"
                    strokeWidth="1"
                />
                <path
                    className="flow-line"
                    d="M-20 260 C 200 360, 380 220, 620 400"
                    stroke="#415A77"
                    strokeWidth="1"
                />
                <path
                    className="flow-line"
                    d="M-20 420 C 180 480, 360 380, 620 560"
                    stroke="#415A77"
                    strokeWidth="1"
                />
            </svg>
        </section>
    );
}
